import Button from "components/base/Button";
import ItemSizeView from "components/shared/ItemSizeView";
import { useModals } from "ModalProvider";
import ProductForm from "./productForm";
import ProductMaterialsView from "./ProductMaterialsView";

const StartUpProjectProductView = ({ project, allMaterials }) => {
  const modal = useModals();

  const productData = JSON.parse(project.data);

  function editHandler() {
    modal.present({
      title: "Edit Product",
      subtitle: project.name,
      children: (
        <ProductForm
          allMaterials={allMaterials}
          originalData={productData}
          projectId={project.id}
          hide={modal.hide}
        />
      ),
    });
  }

  return (
    <div className="space-y-2">
      <table>
        <thead>
          <tr>
            <th colSpan={2}>
              <div className="flex justify-between items-center">
                <div>Basic Information</div>
                <Button onClick={editHandler}>Edit</Button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Size:</td>
            <td className="w-full">
              <ItemSizeView value={productData.size} />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Weight(g):</td>
            <td className="w-full">{productData.weight}</td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td className="align-baseline">Materials:</td>
            <td className="w-full py-0">
              <ProductMaterialsView
                allMaterials={allMaterials}
                product={productData}
              />
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Pantone:</td>
            <td className="w-full whitespace-pre-wrap">
              {productData.pantone}
            </td>
          </tr>
          <tr className="border-y border-gray-100 dark:border-gray-700">
            <td>Remark:</td>
            <td className="w-full whitespace-pre-wrap">{productData.remark}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default StartUpProjectProductView;
